export default __webpack_public_path__ + "static/media/logo13.ae47d1f0.png";